import { render, staticRenderFns } from "./RejectDoc.vue?vue&type=template&id=5147290b&"
import script from "./RejectDoc.vue?vue&type=script&lang=js&"
export * from "./RejectDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports